import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { dashboardActions } from 'srcReact/Dashboard/actions'
import styles from './styles.module.scss'
import parentStyles from '../styles.module.scss'
import Navigation from '../components/common/Navigation'
import NotableEvents from '../components/NotableEvents'
import PendingActions from '../components/PendingActions'
import GroupWPDigest from '../components/GroupWPDigest'
import InterestInsights from '../components/InterestInsights'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import { Toaster } from 'react-hot-toast'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Loader from 'srcReact/components/common2/Loader'

function GroupDashboard({ type, groupId, className }) {
  const dispatch = useDispatch()
  const {
    common: { isMobile, isTablet, isDesktop },
    login: { user: loggedInUser },
    dashboardDetail: { data, header, loading, error }
  } = useSelector((state) => state)

  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    if (!loading && data && !initialized) {
      setInitialized(true)
    }
  }, [data, loading])

  useEffect(() => {
    getGroupDashboardData(groupId)
  }, [groupId])

  const getGroupDashboardData = (id) => {
    if (id && type === 'group') {
      dispatch(dashboardActions.getDashboardData('group', id))
    }
  }

  const showUserLightModal = (modalUser) => {
    const lp = new LightProfileProto()
    lp.userId = modalUser.id || modalUser.user_id
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  return !initialized ? (
    <Loader />
  ) : (
    <div className={`${styles.groupDashboard} ${className}`}>
      {header?.dashboard_group_list?.length > 0 && (
        <Navigation
          type='group'
          list={header?.dashboard_group_list}
          loading={loading}
          id={data?.group_id ?? groupId}
          isMobile={isMobile}
          isTablet={isTablet}
          isDesktop={isDesktop}
        />
      )}

      {!loading ? (
        error ? (
          <ErrorMessage text={error} />
        ) : (
          <div className={parentStyles.dataContainer}>
            <div className={`${parentStyles.row}`}>
              <GroupWPDigest
                type='group'
                digestData={data?.Group_Digest}
                objectId={data?.group_id}
                activityData={data?.Activity}
                loading={loading}
                error={error}
              />
            </div>
            <div className={`${parentStyles.row}`}>
              <NotableEvents
                showUserLightModal={showUserLightModal}
                loading={loading}
                data={data?.Notable_Events}
                groupName={data?.group_name}
                groupId={data?.group_id}
              />
            </div>
            <div className={`${parentStyles.row}`}>
              <PendingActions
                type='group'
                data={data?.Pending_Actions}
                objectId={data?.group_id}
                groupName={data?.group_name}
                autoApprovalToJoin={data?.group_info?.automatic_approval_to_join}
                pendingInvitations={data?.Invitations}
              />
            </div>
            <div className={`${parentStyles.row} `}>
              {<InterestInsights
                type='group'
                groupType={data?.group_info?.group_type}
                objectId={data?.group_id}
                groupName={data?.group_name}
                data={data?.Interest_Insights}
                interestData={data?.Interests}
                loggedInUser={loggedInUser}
              />}
            </div>
          </div>
        )
      ) : null}
      <Toaster />
    </div>
  )
}

export default GroupDashboard
